module.exports = __webpack_public_path__ + "img/ic_pos_androiod@2x.9b39d6d2.jpg";